export default __webpack_public_path__ + "static/media/4-bottom.9190dc16.png";